module.exports = __webpack_public_path__ + "static/img/4.36c591b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/4.png
// module id = xdEI
// module chunks = 35